/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Stats_SandboxesInputs */

const id_components_stats_sandboxes = /** @type {(inputs: Components_Stats_SandboxesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox`)
};

const ms_components_stats_sandboxes = /** @type {(inputs: Components_Stats_SandboxesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox`)
};

const da_components_stats_sandboxes = /** @type {(inputs: Components_Stats_SandboxesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandboxes`)
};

const de_components_stats_sandboxes = /** @type {(inputs: Components_Stats_SandboxesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandboxes`)
};

const en_us2_components_stats_sandboxes = /** @type {(inputs: Components_Stats_SandboxesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandboxes`)
};

const es_es2_components_stats_sandboxes = /** @type {(inputs: Components_Stats_SandboxesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandboxes`)
};

const es_mx2_components_stats_sandboxes = /** @type {(inputs: Components_Stats_SandboxesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandboxes`)
};

const fil_components_stats_sandboxes = /** @type {(inputs: Components_Stats_SandboxesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Sandbox`)
};

const fr_components_stats_sandboxes = /** @type {(inputs: Components_Stats_SandboxesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandboxes`)
};

const it_components_stats_sandboxes = /** @type {(inputs: Components_Stats_SandboxesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox`)
};

const hu_components_stats_sandboxes = /** @type {(inputs: Components_Stats_SandboxesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox-ok`)
};

const nl_components_stats_sandboxes = /** @type {(inputs: Components_Stats_SandboxesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandboxes`)
};

const no_components_stats_sandboxes = /** @type {(inputs: Components_Stats_SandboxesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandboxer`)
};

const pl_components_stats_sandboxes = /** @type {(inputs: Components_Stats_SandboxesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandboxy`)
};

const pt_br2_components_stats_sandboxes = /** @type {(inputs: Components_Stats_SandboxesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandboxes`)
};

const pt_components_stats_sandboxes = /** @type {(inputs: Components_Stats_SandboxesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandboxes`)
};

const ro_components_stats_sandboxes = /** @type {(inputs: Components_Stats_SandboxesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox-uri`)
};

const fi_components_stats_sandboxes = /** @type {(inputs: Components_Stats_SandboxesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hiekkalaatikot`)
};

const sv_components_stats_sandboxes = /** @type {(inputs: Components_Stats_SandboxesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandlådor`)
};

const vi_components_stats_sandboxes = /** @type {(inputs: Components_Stats_SandboxesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox`)
};

const tr_components_stats_sandboxes = /** @type {(inputs: Components_Stats_SandboxesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox'lar`)
};

const cs_components_stats_sandboxes = /** @type {(inputs: Components_Stats_SandboxesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandboxy`)
};

const bg_components_stats_sandboxes = /** @type {(inputs: Components_Stats_SandboxesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox`)
};

const ru_components_stats_sandboxes = /** @type {(inputs: Components_Stats_SandboxesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Песочница`)
};

const uk_components_stats_sandboxes = /** @type {(inputs: Components_Stats_SandboxesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandboxes`)
};

const ar_components_stats_sandboxes = /** @type {(inputs: Components_Stats_SandboxesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandboxes`)
};

const hi_components_stats_sandboxes = /** @type {(inputs: Components_Stats_SandboxesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सैंडबॉक्स`)
};

const th_components_stats_sandboxes = /** @type {(inputs: Components_Stats_SandboxesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แซนด์บ็อกซ์`)
};

const ja_components_stats_sandboxes = /** @type {(inputs: Components_Stats_SandboxesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サンドボックス`)
};

const zh_cn2_components_stats_sandboxes = /** @type {(inputs: Components_Stats_SandboxesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandboxes`)
};

const zh_hant1_components_stats_sandboxes = /** @type {(inputs: Components_Stats_SandboxesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandboxes`)
};

const ko_components_stats_sandboxes = /** @type {(inputs: Components_Stats_SandboxesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandboxes`)
};

/**
* | output |
* | --- |
* | "Sandboxes" |
*
* @param {Components_Stats_SandboxesInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_stats_sandboxes = /** @type {((inputs?: Components_Stats_SandboxesInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Stats_SandboxesInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_stats_sandboxes(inputs)
	if (locale === "ms") return ms_components_stats_sandboxes(inputs)
	if (locale === "da") return da_components_stats_sandboxes(inputs)
	if (locale === "de") return de_components_stats_sandboxes(inputs)
	if (locale === "en-US") return en_us2_components_stats_sandboxes(inputs)
	if (locale === "es-ES") return es_es2_components_stats_sandboxes(inputs)
	if (locale === "es-MX") return es_mx2_components_stats_sandboxes(inputs)
	if (locale === "fil") return fil_components_stats_sandboxes(inputs)
	if (locale === "fr") return fr_components_stats_sandboxes(inputs)
	if (locale === "it") return it_components_stats_sandboxes(inputs)
	if (locale === "hu") return hu_components_stats_sandboxes(inputs)
	if (locale === "nl") return nl_components_stats_sandboxes(inputs)
	if (locale === "no") return no_components_stats_sandboxes(inputs)
	if (locale === "pl") return pl_components_stats_sandboxes(inputs)
	if (locale === "pt-BR") return pt_br2_components_stats_sandboxes(inputs)
	if (locale === "pt") return pt_components_stats_sandboxes(inputs)
	if (locale === "ro") return ro_components_stats_sandboxes(inputs)
	if (locale === "fi") return fi_components_stats_sandboxes(inputs)
	if (locale === "sv") return sv_components_stats_sandboxes(inputs)
	if (locale === "vi") return vi_components_stats_sandboxes(inputs)
	if (locale === "tr") return tr_components_stats_sandboxes(inputs)
	if (locale === "cs") return cs_components_stats_sandboxes(inputs)
	if (locale === "bg") return bg_components_stats_sandboxes(inputs)
	if (locale === "ru") return ru_components_stats_sandboxes(inputs)
	if (locale === "uk") return uk_components_stats_sandboxes(inputs)
	if (locale === "ar") return ar_components_stats_sandboxes(inputs)
	if (locale === "hi") return hi_components_stats_sandboxes(inputs)
	if (locale === "th") return th_components_stats_sandboxes(inputs)
	if (locale === "ja") return ja_components_stats_sandboxes(inputs)
	if (locale === "zh-CN") return zh_cn2_components_stats_sandboxes(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_stats_sandboxes(inputs)
	return ko_components_stats_sandboxes(inputs)
});
export { components_stats_sandboxes as "components.stats.sandboxes" }